import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { X } from "lucide-react";

const STORAGE_KEY = "boscage_cookies_consent";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const saved = typeof window !== "undefined" && window.localStorage.getItem(STORAGE_KEY);
    if (!saved) {
      // Slight delay so it appears after the welcome-location modal is dismissed.
      const t = setTimeout(() => setVisible(true), 800);
      return () => clearTimeout(t);
    }
  }, []);

  const accept = (value) => {
    window.localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({ value, accepted_at: new Date().toISOString() }),
    );
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      data-testid="cookie-banner"
      role="region"
      aria-label="Cookie consent"
      className="fixed inset-x-0 bottom-0 z-[9998] bg-[#0a0a0a] text-white border-t border-white/10"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-5 md:py-6 flex flex-col md:flex-row md:items-center gap-4 md:gap-8">
        <div className="flex-1 text-sm text-white/80 leading-relaxed">
          <p>
            We use cookies to personalize your experience, analyse site
            traffic, and remember your shipping preferences. Read our{" "}
            <Link
              to="/privacy"
              className="text-[#c9a84c] underline underline-offset-4 hover:text-white"
              data-testid="cookie-privacy-link"
            >
              Privacy Policy
            </Link>
            .
          </p>
        </div>

        <div className="flex items-center gap-3 shrink-0">
          <button
            type="button"
            onClick={() => accept("essential")}
            data-testid="cookie-decline-button"
            className="text-[11px] tracking-[0.22em] uppercase text-white/70 hover:text-white px-4 py-2 border border-white/20"
          >
            Essential only
          </button>
          <button
            type="button"
            onClick={() => accept("all")}
            data-testid="cookie-accept-button"
            className="text-[11px] tracking-[0.22em] uppercase text-black bg-white hover:bg-[#c9a84c] px-5 py-3"
          >
            Accept all
          </button>
          <button
            type="button"
            onClick={() => accept("essential")}
            aria-label="Close"
            className="p-1 text-white/60 hover:text-white"
            data-testid="cookie-close-button"
          >
            <X size={16} strokeWidth={1.5} />
          </button>
        </div>
      </div>
    </div>
  );
}
